import { Autocomplete, Box, Button, Chip, TextField } from '@mui/material';
import { withTranslation } from 'react-i18next';

/**
 * Renders a horizontal row of auto-detected filter controls.
 *
 * Props:
 *   filterDefinitions - Array<{ key, type, values }>
 *   activeFilters     - { [key]: selectedValues[] }
 *   onFilterChange    - (key, values) => void
 *   onClearAll        - () => void
 *   t                 - i18next translation function
 */
function InsightsDashboardFilters(props) {
  const { filterDefinitions, activeFilters, onFilterChange, onClearAll, t } = props;

  const hasActiveFilters = Object.values(activeFilters).some(
    v => v && v.length > 0
  );

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2, alignItems: 'center' }}>
      {filterDefinitions.map(({ key, values }) => (
        <Autocomplete
          key={key}
          multiple
          size="small"
          options={values}
          value={activeFilters[key] || []}
          onChange={(_, newValue) => onFilterChange(key, newValue)}
          getOptionLabel={v => String(v)}
          renderTags={(tagValues, getTagProps) =>
            tagValues.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={option}
                label={String(option)}
                size="small"
              />
            ))
          }
          renderInput={params => (
            <TextField
              {...params}
              label={t(`insights_metrics.${key}`, { defaultValue: key })}
              variant="outlined"
            />
          )}
          sx={{ minWidth: 180 }}
        />
      ))}
      {hasActiveFilters && (
        <Button size="small" onClick={onClearAll}>
          {t('Clear filters')}
        </Button>
      )}
    </Box>
  );
}

export default withTranslation()(InsightsDashboardFilters);
